var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 63.3333C63.6816 63.3333 66.6663 60.3486 66.6663 56.6667C66.6663 52.9848 63.6816 50 59.9997 50C56.3178 50 53.333 52.9848 53.333 56.6667C53.333 60.3486 56.3178 63.3333 59.9997 63.3333Z",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3337 36.6667H60.0003C43.3337 36.6667 36.667 43.3334 36.667 60.0001V80.0001C36.667 96.6668 43.3337 103.333 60.0003 103.333H80.0003C96.667 103.333 103.334 96.6668 103.334 80.0001V63.3334",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 46.6667H100.833",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.667 55.8333V37.5",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9004 93.1667L55.3337 82.1334C57.9671 80.3667 61.7671 80.5667 64.1337 82.6L65.2337 83.5667C67.8337 85.8 72.0337 85.8 74.6337 83.5667L88.5004 71.6667C91.1004 69.4334 95.3004 69.4334 97.9004 71.6667L103.334 76.3334",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.855b468f59a5efb53a37635213a9e3ee.svg";
export { ForwardRef as ReactComponent };